import type { MeetingDetail, SetMeetingProjectsRequest } from '../../shared/api-types.js';
import { api } from '../api.js';
import { ProjectFilingDialog } from './project-filing.js';

// The meeting record's "Change projects" (design §7.4, §7.7): the projects a meeting discussed, as Calis filed them
// and as the person chooses them. The person's set replaces the whole filing — a project of Calis's they untick is
// remembered as "not this one" so the next summary does not refile it (ADR 0017) — through
// PATCH /api/meetings/:id/projects, which answers the record as it now stands.

export function MeetingProjectsDialog({ meeting, open, onClose, onSaved }: {
  meeting: Pick<MeetingDetail, 'id' | 'title' | 'projects'>;
  open: boolean;
  onClose: () => void;
  /** The record the server answered, and the ids it held before — what Undo sends back. */
  onSaved: (detail: MeetingDetail, change: { previous: string[]; next: string[] }) => void;
}) {
  return (
    <ProjectFilingDialog<MeetingDetail>
      open={open}
      title="Change projects"
      description={<>The projects <strong>{meeting.title}</strong> belongs to. Calis keeps your choice when it summarises the meeting again.</>}
      initial={meeting.projects.map((project) => project.id)}
      onClose={onClose}
      onApply={(projectIds) => api.patch<MeetingDetail>(`/api/meetings/${encodeURIComponent(meeting.id)}/projects`, { projectIds } satisfies SetMeetingProjectsRequest)}
      onApplied={onSaved}
    />
  );
}
